import PageInformation from './components/Information';

export default PageInformation;
